import React, { useState } from "react";

import ToggleOption from "../../ToggleOption";
import MessagesPage from "../messages/MessagesPage";
import NotifPage from "../messages/NotifPage";

const NotificationsMobilePage = () => {
  const [isGeneral, setIsGeneral] = useState(true);

  return (
    <div className="w-full h-full justify-center items-center p-2 rounded-v-lg  overflow-y-scroll vanda ">
      <div className="w-full flex items-center justify-center">
        <ToggleOption
          toggleType="double"
          fixedAmount={isGeneral}
          trueValue="عمومی "
          falseValue=" شخصی"
          handleSwitchT={() => setIsGeneral(true)}
          handleSwitchF={() => setIsGeneral(false)}
        />
      </div>

      <div>{isGeneral ? <NotifPage /> : <MessagesPage />}</div>
    </div>
  );
};

export default NotificationsMobilePage;
